// Enedis is the source of truth for the address: always replace the current
// fields instead of merging, otherwise a streetNumber already embedded in an
// existing streetName gets duplicated when Enedis returns it separately.
export const getAddressPrefillData = addressData => {
  const addressUpdate = {}

  if (addressData.address) {
    addressUpdate.streetName = addressData.address
  }
  if (addressData.streetNumber) {
    addressUpdate.streetNumber = addressData.streetNumber
  }
  if (addressData.city) {
    addressUpdate.city = addressData.city
  }
  if (addressData.zipcode) {
    addressUpdate.zipcode = addressData.zipcode
  }
  if (addressData.inseeCode) {
    addressUpdate.inseeCode = addressData.inseeCode
  }
  if (addressData.label) {
    addressUpdate.label = addressData.label
  }

  return addressUpdate
}
